import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { RejectExternalProviderBatchRequestBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const rejectExternalProviderBatchRequest = createApiThunk<void, RejectExternalProviderBatchRequestBody>(
  "externalProviderBatchRequests/rejectExternalProviderBatchRequest",
  async (body, { extra: { adminRepository } }) => {
    return adminRepository!.rejectExternalProviderBatchRequest(body);
  },
);

export const resetRejectExternalProviderBatchRequest = createAction(
  "externalProviderBatchRequests/resetRejectExternalProviderBatchRequest",
);
